<app-double-section-page-template>
  <ng-container intro-content>
    <div class="parent-container">
      <div class="flex-container">
        <div class="text-content">
          <h2 double-section-page-template-title>{{ 'contact-form.welcome' | translate }}</h2>
          <h3 [type]="'h3'" double-section-page-template-title>{{ 'contact-form.promise' | translate }}</h3>
        </div>
      </div>
      <div class="bottom-text">
        <span>{{ 'about_us.address.company-name' | translate }}</span
        ><br />
        {{ 'about_us.address.street' | translate }}<br />
        {{ 'about_us.address.city' | translate }}<br />
        {{ 'about_us.address.country' | translate }}<br /><br />
        {{ 'about_us.address.company-no' | translate }}<br />
        {{ 'about_us.address.company-vat' | translate }}
      </div>
    </div>
  </ng-container>
  <ng-container payload-content>
    <form [formGroup]="supportForm" (ngSubmit)="onSubmit()" id="support">
      <fieldset>
        <img src="/assets/icons/chat.svg" double-section-page-template-icon />
        <p class="cm-paragraph cm-form-paragraph">
          <app-textarea-new
            [parent]="supportForm"
            formControlName="message"
            label="contact-form.message-label"
          ></app-textarea-new>
        </p>
        <p class="cm-paragraph cm-form-paragraph">
          <app-email [parent]="supportForm"></app-email>
        </p>
        <p class="cm-paragraph">
          <re-captcha
            #recaptchaRef
            class="my-4"
            (resolved)="recaptchaResolved($event)"
            siteKey="{{ recaptchaSiteKey }}"
          >
          </re-captcha>
        </p>
        <button class="cm-button cm-button-primary" [disabled]="!supportForm.valid || !recaptcha">
          {{ 'contact-form.button-label' | translate }}
        </button>
      </fieldset>
    </form>
  </ng-container>
</app-double-section-page-template>
